import { createHook, createStore, defaults } from 'react-sweet-state';

import { SessionStorageUtilities } from '../utilities/StorageUtilities';

const sideNavOpenKey = 'SideNavOpen';

// Integrate react-sweet-state with the redux dev tools.
defaults.devtools = true;

const SideNavStateStore = createStore({
    name: 'SideNavState',

    initialState: {
        open: SessionStorageUtilities.getJSONValue(sideNavOpenKey, true),
        floating: false,
    },

    actions: {
        setOpen: (open) => {
            return ({ setState }) => {
                setState({
                    open,
                });
                SessionStorageUtilities.setJSONValue(sideNavOpenKey, open);
            };
        },
        setFloating: (floating) => {
            return ({ setState }) => {
                setState({
                    floating,
                });
            };
        },
    },
});

const useSideNavState = createHook(SideNavStateStore);

export default useSideNavState;
